export default {
    validate(value) {
        return Number.isInteger(Number.parseFloat(value))
    }
}
